// assets
import {
    IconUsers,
    IconClipboardList,
    IconBarbell,
    IconCalendarUser,
    IconCalendarPlus,
    IconCalendarCheck,
    IconCalendarCancel,
    IconCalendarStats
} from '@tabler/icons-react';

// constant
const icons = {
    IconUsers,
    IconClipboardList,
    IconBarbell,
    IconCalendarUser,
    IconCalendarPlus,
    IconCalendarCheck,
    IconCalendarCancel,
    IconCalendarStats
};

// ==============================|| SERVICE MENU ITEMS ||============================== //

const service = {
    id: 'service',
    title: '검사 조회',
    type: 'group',
    children: [
        {
            id: 'exam-all',
            title: '전체 검사 내역',
            type: 'item',
            url: '/service/exam/all',
            icon: icons.IconCalendarUser,
            breadcrumbs: true,
            children: [
                {
                    id: 'exam_detail',
                    title: '검사 결과 상세',
                    type: 'item',
                    url: '/service/exam/all/:id',
                    icon: icons.IconCalendarUser,
                    breadcrumbs: true
                }
            ]
        },
        {
            id: 'exam-registered',
            title: '시작 전 검사',
            type: 'item',
            url: '/service/exam/registered',
            icon: IconCalendarStats,
            breadcrumbs: true,
            children: [
                {
                    id: 'exam_detail',
                    title: '검사 결과 상세',
                    type: 'item',
                    url: '/service/exam/registered/:id',
                    icon: icons.IconCalendarUser,
                    breadcrumbs: true
                }
            ]
        },
        {
            id: 'exam-completed',
            title: '완료된 검사',
            type: 'item',
            url: '/service/exam/completed',
            icon: IconCalendarCheck,
            breadcrumbs: true,
            children: [
                {
                    id: 'exam_detail',
                    title: '검사 결과 상세',
                    type: 'item',
                    url: '/service/exam/completed/:id',
                    icon: icons.IconCalendarUser,
                    breadcrumbs: true
                }
            ]
        },
        {
            id: 'exam-cancelled',
            title: '취소된 검사',
            type: 'item',
            url: '/service/exam/cancelled',
            icon: IconCalendarCancel,
            breadcrumbs: false,
            children: [
                {
                    id: 'exam_detail',
                    title: '검사 결과 상세',
                    type: 'item',
                    url: '/service/exam/cancelled/:id',
                    icon: icons.IconCalendarUser,
                    breadcrumbs: true
                }
            ]
        }
    ]
};

export default service;
